module.exports = __webpack_public_path__ + "static/img/home_case_logoWall_h5.770b18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_logoWall_h5.png
// module id = qbpg
// module chunks = 34